import { Box, Typography } from "@mui/material";
import { MYLIST_APP } from "../constants/constants";

export const ItemPropertyImage = ({ image }) => {
    return (
        <Box sx={{ border: 1, borderColor: 'divider', borderRadius: '10px', width: '100%', maxWidth: '300px', aspectRatio: '1 / 1', alignItems: 'center', display: 'flex', justifyContent: 'center', padding: '8px', bgcolor: 'background.default' }}>
            {image ?
                <img alt="" style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', objectFit: 'contain' }} src={`${MYLIST_APP.S3_BUCKET_HOST}/${image}`} />
            : <Typography variant="body2" color="text.secondary">No image</Typography>}
        </Box>
    );
}
